<script>
import { mapActions } from 'vuex'
import { add, edit } from '@/api/usuario'
import fields from './fields'
import { setFocus } from '@/services/crud'

export default {
  props: {
    mode: { type: String, default: 'tab' }
  },
  data: () => ({
    fields,
    form: {}
  }),
  methods: {
    ...mapActions({
      toaster: 'modal/toaster'
    }),
    focuInicial () {
      setFocus('input[type="text"]', this.$refs.form.$el)
    },
    refresh (data) {
      this.form = JSON.parse(JSON.stringify(data))
      if (!this.form.id) this.$refs.form.instance.resetValues()
      this.focuInicial()
    },
    trataDados () {
      if (this.form.senha && this.form.confirma_senha && this.form.senha !== this.form.confirma_senha) throw new Error('Confirmar senha incorreto!')
      let dados = JSON.parse(JSON.stringify(this.form))
      if (!dados.senha) delete dados.senha
      if (!dados.confirma_senha) delete dados.confirma_senha
      return dados
    },
    async salvar () {
      // Salvar Editar
      try {
        let valida = this.$refs.form.instance.validate()
        if (!valida.isValid) throw new Error('Campos Inválidos')
        let data = {}
        let dados = this.trataDados()
        if (dados.id) {
          data = await edit(dados.id, dados)
          this.toaster({ message: 'Adicionado com sucesso!', color: 'success' })
        // Salvar Novo
        } else {
          data = await add(dados)
          this.toaster({ message: 'Editado com sucesso!', color: 'success' })
        }
        this.$emit('save', data)
      } catch (e) {
        this.toaster({ message: e.message, color: 'error' })
      }
    }
  }
}
</script>

<template>
  <ui-layout-modal :mode="mode" title="Adicionar" @onClose="() => $emit('cancel')">
    <dx-form ref="form" label-location="top" :form-data="form" :items="fields" :onEditorEnterKey="salvar">
      <app-acessogrupo-select slot="fieldGrupo" slot-scope="data" :model="form.acesso_grupo" @change="v => form.acesso_grupo = v" />
    </dx-form>
    <ui-acao-form @save="salvar" @cancel="$emit('cancel')" />
  </ui-layout-modal>
</template>

<style scoped>
  .card-form {
    text-align: left;
  }
</style>
